export * from './useUpdateGlobalCompanyTab';
export { default as useUpdateGlobalCompanyTab } from './useUpdateGlobalCompanyTab';
